import { BadgeCheck } from "lucide-react";

/**
 * Servrevu "Verified Pro" trust badge.
 * Shown when a business is claimed, has at least one review,
 * has uploaded a logo, and has at least one gallery photo.
 */
export default function VerifiedBadge({ size = 16, className = "", showLabel = false }) {
  return (
    <span
      className={`inline-flex items-center gap-1 text-[#1e88e5] ${className}`}
      title="Verified Pro — claimed listing with reviews, a logo, and work photos."
      aria-label="Verified Pro"
      data-testid="verified-badge"
    >
      <BadgeCheck size={size} className="fill-[#1e88e5] text-white" strokeWidth={2.5} />
      {showLabel && <span className="text-xs font-medium">Verified Pro</span>}
    </span>
  );
}
